import toast from "react-hot-toast";
import { apiconnector } from "../apiconnector";
import { studentEndpoints } from "../apis";
import rzpLogo from '../../assets/Logo/rzp_logo.png'
import { setPaymentLoading } from "../../slices/courseSlice";
import { resetCart } from "../../slices/cartSlice";

const {COURSE_PAYMENT_API, COURSE_VERIFY_API, SEND_PAYMENT_SUCCESS_EMAIL_API} = studentEndpoints;


function loadScript(src){
    return new Promise((resolve)=>{
        const script = document.createElement("script")
        script.src=src

        script.onload=()=>{
            resolve(true);
        }

        script.onerror=()=>{
            resolve(false);
        }

        document.body.appendChild(script)

    })
}

export async function buyCourse(token , courses , userDetails , navigate , dispatch){
    const toastId = toast.loading("Loading...")
    try{

        // Load the script
        const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js")

        console.log("Script Load", res);

        if(!res){
            toast.error("RazorPay SDK failed to load");
            return;
        }

        // initate the order
        const orderResponse = await apiconnector("POST" , COURSE_PAYMENT_API , {courses}, { Authorization: `Bearer ${token}`,})

        if(!orderResponse.data.success){
            throw new Error(orderResponse.data.message)
        }

        // console.log("PRINTING orderResponse", orderResponse);
        console.log(userDetails)

        // options
        

        const options = {
            key: process.env.REACT_APP_RAZORPAY_KEY,
            currency: orderResponse.data.data.currency,
            amount: `${orderResponse.data.data.amount}`,
            order_id: orderResponse.data.data.id,
            name:"StudyNotion",
            description: "Thank You for Purchasing the Course",
            image:rzpLogo,
            prefill:{
                name:`${userDetails.firstName}`,
                email:userDetails.email
            },
            handler: function (response){

                // verify Payment
                verifyPayment({...response, courses}, token, navigate, dispatch);
                // send successfull wala email
                sendPaymentSuccessEmail(response, orderResponse.data.data.amount,token );
                // console.log("PRINTING RESPOSNE >>>>" , response)
            }
        }

        // miss hogya tha
        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
        paymentObject.on("payment.failed", function(response) {
            toast.error("oops, payment failed");
            console.log(response.error);
        })
    }
    catch(err){
        console.log("PAYMENT API ERROR.....", err);
        toast.error("Could not make Payment");
    }

    toast.dismiss(toastId);
}


// Send email after payment successfull
async function sendPaymentSuccessEmail(response, amount, token) {
    try{
        await apiconnector("POST", SEND_PAYMENT_SUCCESS_EMAIL_API, {
            orderId: response.razorpay_order_id,
            paymentId: response.razorpay_payment_id,
            amount,
        },{
            Authorization: `Bearer ${token}`
        })
    }
    catch(error) {
        console.log("PAYMENT SUCCESS EMAIL ERROR....", error);
    }
}


//verify payment
async function verifyPayment(bodyData, token, navigate, dispatch) {
    const toastId = toast.loading("Verifying Payment....");
    dispatch(setPaymentLoading(true));
    try{
        const response  = await apiconnector("POST", COURSE_VERIFY_API, bodyData, {
            Authorization:`Bearer ${token}`,
        })

        if(!response.data.success) {
            throw new Error(response.data.message);
        }
        toast.success("Payment Successful, You are addded to the course");
        navigate("/dashboard/enrolled-courses");
        dispatch(resetCart());
    }   
    catch(error) {
        console.log("PAYMENT VERIFY ERROR....", error);
        toast.error("Could not verify Payment");
    }
    toast.dismiss(toastId);
    dispatch(setPaymentLoading(false));
}